import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "share-fb",
  "use": "share-fb-usage",
  "viewBox": "0 0 24.12 24.02",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24.12 24.02\" id=\"share-fb\"><defs><style>#share-fb .cls-1{fill:#342f41;}</style></defs><g id=\"share-fb_Layer_2\" data-name=\"Layer 2\"><g id=\"share-fb_Layer_1-2\" data-name=\"Layer 1\"><path class=\"cls-1\" d=\"M12.06,0a12.05,12.05,0,0,0-2,23.94V14.57H7.14V11.2h2.91V8.72c0-2.88,1.76-4.45,4.33-4.45A24.48,24.48,0,0,1,17,4.4v3H15.19c-1.4,0-1.67.67-1.67,1.64V11.2h3.34l-.43,3.37H13.52V24A12.05,12.05,0,0,0,12.06,0Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol